import styled from 'styled-components';
import { colors, layout } from '@prisjakt/ui-base';
import TooltipComponent from '@prisjakt/ui-tooltip-new';

const Tooltip = styled(TooltipComponent)``;

const CompareProductButton = styled.button`
  display: flex;
  align-items: center;
  align-self: stretch;
  outline: none;
  cursor: pointer;
  padding: 0 ${layout.spacing.xxSmall};
  min-height: 43px;
  position: relative;

  ${Tooltip} {
    transition: visibility 0s 0.1s, opacity 0.1s linear;
    visibility: hidden;
    opacity: 0;
    z-index: 9999;
  }

  :hover ${Tooltip} {
    transition: visibility 0s, opacity 0.2s linear;
    visibility: visible;
    opacity: 1;
  }
`;

type CompareIconWrapperProps = { active?: boolean };
export const CompareIconWrapper = styled.div<CompareIconWrapperProps>`
  background-color: ${({ theme, active }) =>
    active ? theme.bg.productCompare : 'transparent'};
  border-radius: ${layout.borderRadius};
  color: ${({ theme, active }) =>
    active ? colors.darkBlue1 : theme.icons.callToAction};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;

  :hover {
    color: ${({ theme, active }) =>
      active ? colors.darkBlue1 : theme.icons.callToActionHover};
  }
`;

export { Tooltip, CompareProductButton };
